import "./Spinner.css";

const Spinner = ({ small = false }) => (
  <div
    className={`loading-spinner ${small ? "loading-spinner--small" : null}`}
  ></div>
);

export default Spinner;
